import Keycloak from "keycloak-js";
import { parseJwt } from "../lib/utils";

const _kc = new Keycloak('/keycloak.json');

/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */
const initKeycloak = (onAuthenticatedCallback: () => void) => {
  _kc.init({
    onLoad: 'check-sso', //'login-required'
    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
    pkceMethod: 'S256',
  })
    .then((authenticated) => {
      if (!authenticated) {
        console.log("user is not authenticated..!");
        doLogin();
      }
      onAuthenticatedCallback();
    })
    .catch(console.error);
};

const doLogin = _kc.login;

const doLogout = _kc.logout;

const getToken = () => _kc.token;

const isLoggedIn = () => !!_kc.token;

const updateToken = (successCallback: any) =>
  _kc.updateToken(5)
    .then(successCallback)
    .catch(doLogin);

const getUsername = () => _kc.tokenParsed?.preferred_username;
const getUser = () => _kc.tokenParsed;

const hasRole = (roles: any) => roles.some((role: any) => _kc.hasRealmRole(role));

const ensureToken = async () => {
  let jwt = getToken();
  if(jwt){
    const parsedJwt = parseJwt(jwt);
    const expiration = parsedJwt.exp*1000;
    if(new Date().getTime() >= expiration){
      await Promise.all([updateToken(1)]);
    }
  }
}

const UserService = {
  initKeycloak,
  doLogin,
  doLogout,
  isLoggedIn,
  getToken,
  updateToken,
  getUser,
  getUsername,
  hasRole,
  ensureToken
};

export default UserService;